import 'bootstrap'
import Vue from 'vue/dist/vue.esm.js'
import Router from 'vue-router'

import inputform from './components/popysample/input'
import childEdit from './components/popysample/child'
import child2Edit from './components/popysample/child2'
import parentEdit from './components/popysample/parent'
import enqueteEdit from './components/popysample/enquete'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      component: inputform
    },
    {
      path: '/child-edit',
      component: childEdit
    },
    {
      path: '/child2-edit',
      component: child2Edit
    },
    {
      path: '/parent-edit',
      component: parentEdit
    },
    {
      path: '/enquete-edit',
      component: enqueteEdit
    },
  ],
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

const is_input = document.querySelector('.mw_wp_form').classList.contains('mw_wp_form_input')
const is_confirm = document.querySelector('.mw_wp_form').classList.contains('mw_wp_form_confirm')
const is_finish = document.querySelector('.mw_wp_form').classList.contains('mw_wp_form_complete')

new Vue({
  el: '[data-app="popysample"]',
  router,
  data: {
      is_input,
      is_confirm,
      is_finish,
      is_initial: true,
      is_child2: false,
      formdata: {
        popy: '',
        pke: '',
        c2popy: '',
        c2pke: '',
        school_suffix: '',
        c2school_suffix: '',
        enquete: '',
      }
  },
  methods: {
    initialized () {
      this.is_initial = false
    },
    sectionAvailableToggle ( section ) {
      this[`is_${section}`] = !this[`is_${section}`]
    },
    updState ( key, state ) {
      this[key] = state
    },
    updInputs ( inputs ) {
      Object.keys( inputs ).forEach( key => {
        this.$set( this.formdata, key, inputs[key] )
      })
    },
    updSection ( editdata ) {
      Object.keys( editdata ).forEach( key => {
        this.formdata[key] = editdata[key]
      })
    }
  }
})